import { createStore } from 'vuex';

import auth from './auth';
import users from './users';
import labels from './labels';
import purchases from './purchases';
import serialSearch from './serialSearch';
import packedSearch from './packedSearch';
import reuseSerials from './reuseSerials';
import fileManager from './fileManager';
import logoUploader from './logoUploader';


export default createStore({
  modules: {
    auth,
    users,
    labels,
    purchases,
    serialSearch,
    packedSearch,
    reuseSerials,
    fileManager,
    logoUploader,
  }
});